// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"ip-z","breadcrumbForward":"jp-z","breadcrumbBack":"kp-z","selected":"lp-z"};